module.exports = __webpack_public_path__ + "static/media/update.c4847591.png";